var _ExpandMore;
var _excluded = ["children", "className", "classes", "data-testid", "disabled", "menuItems", "menuTooltipText", "onClick", "tooltipText", "variant"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { string, object, bool, oneOf, func, node } from 'prop-types';
import { ExpandMore } from 'mosaic-react-icons';
import { alpha, styled } from '@mui/material/styles';
import SovosButton from "../sovos-button";
import SovosIconMenu from "../sovos-icon-menu";
import buttonStyles from "../internals/utils/buttonStyles";
var boxShadow = buttonStyles.boxShadow;
var Root = styled('div')({
  alignItems: 'center',
  display: 'flex'
});
var DefaultButton = styled(SovosButton)(function (_ref) {
  var variant = _ref.variant,
    spacing = _ref.theme.spacing;
  return {
    borderRadius: "".concat(spacing(1), " 0  0 ").concat(spacing(1)),
    '&:hover': {
      boxShadow: variant === 'text' ? 'none' : boxShadow
    }
  };
});
var IconMenu = styled(SovosIconMenu)(function (_ref2) {
  var variant = _ref2.variant,
    IconButtonProps = _ref2.IconButtonProps,
    _ref2$theme = _ref2.theme,
    spacing = _ref2$theme.spacing,
    palette = _ref2$theme.palette;
  var disabled = IconButtonProps.disabled;
  var height = spacing(4);
  var borderRadius = "0 ".concat(spacing(1), " ").concat(spacing(1), " 0");
  var outline = {
    '&:focus-visible::after': {
      outlineOffset: 4
    }
  };
  var borderStyle = disabled ? "1px solid ".concat(alpha("".concat(palette.text.disabled), 0.25)) : "1px solid ".concat(alpha("".concat(palette.text.contrast), 0.25));
  if (variant === 'text') {
    return _objectSpread({
      height: height,
      '&.sovosIconButton': {
        color: disabled ? palette.text.disabled : palette.primary.main
      },
      '&:hover': {
        backgroundColor: alpha(palette.primary.main, palette.action.hoverOpacity),
        borderRadius: borderRadius,
        '&:focus': {
          backgroundColor: alpha(palette.primary.main, palette.action.hoverOpacity)
        }
      }
    }, outline);
  }
  return _objectSpread({
    borderInlineStart: borderStyle,
    height: height,
    borderRadius: borderRadius,
    boxShadow: boxShadow,
    '&.sovosIconButton': {
      backgroundColor: disabled ? palette.grey[300] : palette.primary.main,
      color: disabled ? palette.text.disabled : palette.primary.contrastText
    },
    '&:hover': {
      backgroundColor: palette.primary.dark,
      boxShadow: boxShadow
    },
    '&:hover:focus': {
      backgroundColor: palette.primary.dark
    }
  }, outline);
});
var SovosSplitButton = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
    className = _ref3.className,
    classes = _ref3.classes,
    dataTestId = _ref3['data-testid'],
    _ref3$disabled = _ref3.disabled,
    disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
    menuItems = _ref3.menuItems,
    menuTooltipText = _ref3.menuTooltipText,
    onClick = _ref3.onClick,
    tooltipText = _ref3.tooltipText,
    _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? 'contained' : _ref3$variant,
    rest = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(Root, _extends({
    className: clsx('sovosSplitIcon', className),
    "data-testid": dataTestId
  }, rest), /*#__PURE__*/React.createElement(DefaultButton, {
    disableRipple: true,
    disabled: disabled,
    onClick: onClick,
    tooltipText: tooltipText,
    variant: variant
  }, children), /*#__PURE__*/React.createElement(IconMenu, {
    IconButtonProps: {
      disabled: disabled
    },
    iconElement: _ExpandMore || (_ExpandMore = /*#__PURE__*/React.createElement(ExpandMore, null)),
    ref: ref,
    tooltipText: menuTooltipText,
    variant: variant
  }, menuItems));
});
SovosSplitButton.propTypes = {
  /**
   * Override or extend the styles applied to the component
   */
  classes: object,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * Default action component
   */
  children: node,
  /**
   * @ignore
   */
  'data-testid': string,
  /**
   * If `true`, the button is disabled
   */
  disabled: bool,
  /**
   * The content of the menu. Must be an array of `SovosMenuItem` or `SovosDivider`
   */
  menuItems: node.isRequired,
  /**
   * Menu Tooltip text
   */
  menuTooltipText: string,
  /**
   * Callback fired when the button is clicked.
   */
  onClick: func,
  /**
   * Tooltip text
   */
  tooltipText: string,
  /**
   * Button variant
   */
  variant: oneOf(['contained', 'text'])
};
export default SovosSplitButton;